
import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-presentation-line',
    title: 'Training Delivery & Facilitation',
    desc: 'Expert facilitators delivering engaging, interactive sessions tailored to your industry and organisational goals.',
    href: '/corporate-training',
  },
  {
    icon: 'ri-checkbox-multiple-line',
    title: 'Assessment & Moderation',
    desc: 'Comprehensive assessment services ensuring learners meet required competency standards with rigorous quality assurance.',
    href: '/corporate-training',
  },
  {
    icon: 'ri-book-2-line',
    title: 'Material Design & Development',
    desc: 'Custom learning materials designed to maximise training effectiveness and improve learner engagement.',
    href: '/corporate-training',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'SDF Advisory Services',
    desc: 'Strategic guidance for Skills Development Facilitators to maximise training investment and SETA grant returns.',
    href: '/seta-compliance',
  },
  {
    icon: 'ri-team-line',
    title: 'Internship & Graduate Placement',
    desc: 'Connecting qualified learners with meaningful employment, bridging the gap between training and industry.',
    href: '/corporate-training',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'SETA Compliance Support',
    desc: 'Expert assistance with SETA requirements, WSP/ATR reporting, and comprehensive compliance management.',
    href: '/seta-compliance',
  },
];

export default function ServicesSection() {
  return (
    <section className="section-wrap bg-[#f8f9fa]">
      <div className="section-inner">

        <div className="text-center mb-14 reveal">
          <p className="section-label justify-center">What We Offer</p>
          <h2 className="section-heading mx-auto" style={{ maxWidth: '460px' }}>Our Core Services</h2>
          <p className="section-body mx-auto text-center">
            Comprehensive training solutions built around your organisation's unique skills development needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 reveal-children">
          {SERVICES.map((s, i) => (
            <div key={i} className="card p-7 group">
              <div className="icon-box mb-5">
                <i className={s.icon} />
              </div>
              <h3 className="font-sans font-semibold text-[#111111] text-base mb-3">{s.title}</h3>
              <p className="text-[#6b7280] text-sm leading-relaxed mb-5">{s.desc}</p>
              <Link
                to={s.href}
                className="inline-flex items-center gap-1.5 text-xs font-bold text-[#2D7F3E] uppercase tracking-wide hover:gap-3 transition-all duration-200"
              >
                Learn more <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
